import React from 'react';

const XervixLoader = () => {
  return (
    <div className="flex items-center justify-center ">
      <div className="relative w-32 h-32">
        {/* Animated Circle with Network Nodes */}
        <div className="absolute inset-0">
          <svg 
            className="w-full h-full animate-spin" 
            style={{ 
              animation: 'spin 2s ease-in-out infinite',
              transformOrigin: 'center'
            }}
            viewBox="0 0 128 128"
            xmlns="http://www.w3.org/2000/svg"
          >
            {/* Network Connection Lines */}
            <circle
              cx="64"
              cy="64"
              r="50"
              fill="none"
              stroke="#F97068"
              strokeWidth="1"
              opacity="0.3"
              strokeDasharray="8 4"
            />
            
            {/* Animated Network Nodes */}
            {[...Array(8)].map((_, i) => {
              const angle = (i * 360) / 8;
              const x = 64 + 50 * Math.cos((angle * Math.PI) / 180);
              const y = 64 + 50 * Math.sin((angle * Math.PI) / 180);
              
              return (
                <g key={i}>
                  {/* Connection Lines to Center */}
                  <line
                    x1={x}
                    y1={y}
                    x2="64"
                    y2="64"
                    stroke="#F97068"
                    strokeWidth="1"
                    opacity="0.4"
                    className="animate-pulse"
                    style={{
                      animationDelay: `${i * 0.25}s`,
                      animationDuration: '2s'
                    }}
                  />
                  
                  {/* Network Nodes */}
                  <circle
                    cx={x}
                    cy={y}
                    r="3"
                    fill="#F97068"
                    className="animate-pulse"
                    style={{
                      animationDelay: `${i * 0.25}s`,
                      animationDuration: '2s'
                    }}
                  />
                  
                  {/* Glowing Effect */}
                  <circle
                    cx={x}
                    cy={y}
                    r="6"
                    fill="none"
                    stroke="#F97068"
                    strokeWidth="1"
                    opacity="0.3"
                    className="animate-ping"
                    style={{
                      animationDelay: `${i * 0.25}s`,
                      animationDuration: '2s'
                    }}
                  />
                </g>
              );
            })}
          </svg>
        </div>

        {/* Central X Logo */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div 
            className="relative"
            style={{
              animation: 'xPulse 2s ease-in-out infinite'
            }}
          >
            {/* X Shape */}
            <svg 
              width="40" 
              height="40" 
              viewBox="0 0 24 24" 
              className="relative z-10"
            >
              <path
                d="M18 6L6 18M6 6l12 12"
                stroke="#F97068"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
              />
            </svg>
            
            {/* Pink Glow Effect - Multiple Layers */}
            <div 
              className="absolute inset-0 bg-pink-400 rounded-full blur-lg opacity-40"
              style={{
                animation: 'xGlow 2s ease-in-out infinite',
                transform: 'scale(1.5)'
              }}
            />
            <div 
              className="absolute inset-0 bg-pink-300 rounded-full blur-md opacity-30"
              style={{
                animation: 'xGlow 2s ease-in-out infinite',
                transform: 'scale(1.2)',
                animationDelay: '0.3s'
              }}
            />
            <div 
              className="absolute inset-0 bg-[#F97068] rounded-full blur-sm opacity-50"
              style={{
                animation: 'xGlow 2s ease-in-out infinite',
                animationDelay: '0.6s'
              }}
            />
          </div>
        </div>

        {/* Orbiting Connection Indicator */}
        <div 
          className="absolute inset-0"
          style={{
            animation: 'orbit 2s linear infinite'
          }}
        >
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1">
            <div className="w-2 h-2 bg-[#F97068] rounded-full shadow-lg shadow-[#F97068]/50" />
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        @keyframes xPulse {
          0%, 100% {
            transform: scale(1);
            opacity: 1;
          }
          50% {
            transform: scale(1.2);
            opacity: 0.8;
          }
        }

        @keyframes xGlow {
          0%, 100% {
            opacity: 0.3;
            transform: scale(0.8);
          }
          50% {
            opacity: 0.8;
            transform: scale(1.4);
          }
        }

        @keyframes orbit {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
};

export default XervixLoader;